import { DataTableFilterMetaData } from "primereact/datatable";

import Axios from "../../../_helpers/axiosHelper";
import { LazyTableState } from "../../../common/interfaces.ts";
import { IBuilding, IResponsePaginateServices } from "../reducers";

export const addBuilding = (building: IBuilding) => {
  return Axios.post(`/agency/building`, building);
};

export const getBuilding = (id: string): Promise<IBuilding> => {
  return Axios.get(`/agency/building/${id}`);
};

export const getBuildings = (
  options: LazyTableState,
): Promise<IResponsePaginateServices> => {
  const individualOrders: any = {};
  if (options?.multiSortMeta && options.multiSortMeta.length > 0) {
    for (const sort of options.multiSortMeta) {
      individualOrders[sort.field] = sort.order === 1 ? "asc" : "desc";
    }
  }
  const individualFilters: any = {};
  if (options?.filters) {
    for (const [key, value] of Object.entries(options.filters)) {
      individualFilters[key] = (value as DataTableFilterMetaData)?.value;
    }
  }
  return Axios.get("/agencies/buildings", {
    params: {
      page: options?.page ? options.page + 1 : 1,
      // perPage: options.rows,
      filter: options.filter,
      // individualOrders,
      // individualFilters,
    },
  });
};

export const getBuildingDwellings = (page: string, buildingId: string) => {
  return Axios.get(`/agency/building/${buildingId}/dwellings`, {
    params: { page },
  });
};

export const updateBuilding = (building: IBuilding, buildingId: string) => {
  return Axios.put(`/agency/building/${buildingId}`, building);
};

export const uploadBuildingFiles = (id: string, files: any[]) => {
  const formData = new FormData();
  files.forEach((file, index) => {
    formData.append(`files[${index}][content]`, file.content);
    if (file.url) {
      formData.append(`files[${index}][exist]`, "true");
    }
    formData.append(`files[${index}][type][label]`, file.type.label);
    formData.append(`files[${index}][type][value]`, file.type.value);
  });

  return Axios.post(`/agency/building/${id}/files`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const removeBuildingFile = (buildingId: string, fileId: string) => {
  return Axios.delete(`/agency/building/${buildingId}/file/${fileId}`);
};

export const deleteBuilding = (buildingId: string) => {
  return Axios.delete(`/agency/building/${buildingId}`);
};
